import jQuery from 'jquery';
export { jQuery, jQuery as $ };
